import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-description-box",
  templateUrl: "./description-box.component.html",
  styleUrls: ["./description-box.component.css"],
})
export class DescriptionBoxComponent implements OnInit {
  @Input() title: string;
  @Input() message: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {
    console.log("message", this.message);
    let vFrame = document.getElementById("my_description");
    if (vFrame) {
      vFrame.outerHTML = this.message.description;
    }
  }

  public decline() {
    this.activeModal.close();
  }

  public accept() {
    this.activeModal.close();
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
